import api from '@/api'

const SET_ANIMAL_TYPES = 'SET_ANIMAL_TYPES'
const ADD_ANIMAL_TYPE = 'ADD_ANIMAL_TYPE'

const SET_ANIMAL_TYPES_LIST = 'SET_ANIMAL_TYPES_LIST'

const SET_ANIMAL_TYPE = 'SET_ANIMAL_TYPE'
const UNSET_ANIMAL_TYPE = 'UNSET_ANIMAL_TYPE'

const SET_COUNT = 'SET_COUNT'

export default {
  namespaced: true,

  state () {
    return {
      animalTypes: [],
      animalTypesList: [],
      currentAnimalType: null,
      count: 0
    }
  },

  getters: {
    animalTypes: (state) => state.animalTypes,
    animalTypesList: (state) => state.animalTypesList,
    currentAnimalType: (state) => state.currentAnimalType,
    count: (state) => state.count
  },

  mutations: {
    [SET_ANIMAL_TYPES] (state, data) {
      state.animalTypes = data
    },

    [SET_ANIMAL_TYPES_LIST] (state, data) {
      state.animalTypesList = data
    },

    [ADD_ANIMAL_TYPE] (state, data) {
      state.animalTypes.shift(data)
    },

    [SET_ANIMAL_TYPE] (state, data) {
      state.currentAnimalType = data
    },

    [UNSET_ANIMAL_TYPE] (state) {
      state.currentAnimalType = null
    },

    [SET_COUNT] (state, count) {
      state.count = count
    }
  },

  actions: {
    async loadAnimalTypes ({ commit }, params = {}) {
      const { data, count } = await api.animaltypes.list(params)
      commit(SET_ANIMAL_TYPES, data || [])
      commit(SET_COUNT, count || 0)
      return { data, count }
    },

    async createAnimalType ({ dispatch }, payload) {
      const { error } = await api.animaltypes.create(payload)
      const filters = { farm: payload.farm }
      dispatch('loadAnimalTypes', filters)
      return error
    },

    async loadAnimalTypesList ({ commit }, params = {}) {
      const filters = {}
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data } = await api.animaltypes.litelist(filters)
      commit(SET_ANIMAL_TYPES_LIST, data)
      return data
    },

    async selectAnimalType ({ commit }, id) {
      const { data } = await api.animaltypes.getById(id)
      commit(SET_ANIMAL_TYPE, data)
      return data
    },

    async updateAnimalType ({ commit, dispatch, getters }) {
      const item = getters.currentAnimalType
      const { error } = await api.animaltypes.updateById(item.id, item)
      const params = { farm: item.farm }
      dispatch('loadAnimalTypes', params)
      if (!error) {
        commit(UNSET_ANIMAL_TYPE)
      }
      return error
    },

    async deleteAnimalType ({ commit, dispatch, getters }) {
      const item = getters.currentAnimalType
      await api.animaltypes.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadAnimalTypes', params)
      commit(UNSET_ANIMAL_TYPE)
    },

    closeAnimalType ({ commit }) {
      commit(UNSET_ANIMAL_TYPE)
    }
  }
}
